import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TopHeader from './Components/TopHeader';
import Sidebarr from './Components/Sidebaar';
import { BrowserRouter as Router} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './Components/Header';
import { SidebarProvider } from './Utility/SidebaarContext';


// Create a top-level header component

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <Router>
      {/* <TopHeader />
      <Sidebarr /> */}
      <SidebarProvider>
      <Header/>
        <App />
        </SidebarProvider>
    </Router>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
